import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { SelectFetchConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { SelectFetchService } from './api/selectFetch.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class SelectFetchApiModule {
    public static forRoot(configurationFactory: () => SelectFetchConfiguration): ModuleWithProviders<SelectFetchApiModule> {
        return {
            ngModule: SelectFetchApiModule,
            providers: [ { provide: SelectFetchConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: SelectFetchApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('SelectFetchApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
